import { alpha } from '@mui/material';

import type { Theme } from '../../themes/themes';

export const createSliderFieldTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiSlider: {
      styleOverrides: {
        root: {
          marginTop: theme.spacing(3), // to bring parity with outlined input fields
        },
        mark: {
          color: theme.palette.surface.default,
        },
        markLabel: {
          color: theme.palette.labeling.inputDefault,
          ".MuiSlider-markedAuto > &[data-index='0'], .MuiSlider-markedInout > &[data-index='0']": {
            transform: 'translateX(0%)', // left align the first one
          },
          '.MuiSlider-markedAuto > &:nth-last-child(2), .MuiSlider-markedInout > &:nth-last-child(2)': {
            transform: 'translateX(-100%)', // right align the last one
          },
        },
        markLabelActive: {
          color: theme.palette.labeling.inputDefault,
        },
        valueLabel: {
          ...theme.typography.button,
          backgroundColor: theme.palette.surface.indeterminate,
          color: theme.palette.surface.default,
          borderRadius: theme.spacing(2),
          paddingTop: theme.spacing(2),
          paddingBottom: theme.spacing(2),
          paddingLeft: theme.spacing(3),
          paddingRight: theme.spacing(3),
          [theme.breakpoints.up('md')]: {
            borderRadius: theme.spacing(3),
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3),
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
          },
        },
        thumb: {
          borderWidth: 2,
          borderStyle: 'solid',
          borderColor: theme.palette.surface.indeterminate,
          outlineWidth: 0,
          outlineStyle: 'none',
          outlineColor: theme.palette.border.defaultFocus,
          color: theme.palette.surface.default,
          '.Mui-disabled > &': {
            borderColor: theme.palette.border.defaultDisabled,
          },
          boxSizing: 'border-box',

          width: 16,
          height: 16,
          [theme.breakpoints.up('md')]: {
            width: 24,
            height: 24,
          },

          '&:hover': {
            boxShadow: `0px 0px 0px 8px ${alpha(theme.palette.surface.positive, 0.1)}`,
          },

          // blue ring + 2 px white
          '&.Mui-focusVisible': {
            outlineWidth: 2,
            outlineOffset: 2,
            outlineStyle: 'solid',
            boxShadow: `0px 0px 0px 2px ${theme.palette.surface.default}`,
          },

          // 8px green opaque ring
          '&.Mui-active': {
            outlineWidth: 0,
            outlineStyle: 'none',
            outlineColor: theme.palette.border.defaultFocus,
            boxShadow: `0px 0px 0px 8px ${alpha(theme.palette.surface.positive, 0.2)}`,
          },
        },
        track: {
          opacity: 1.0,
          color: theme.palette.surface.positive,
          '.Mui-disabled > &': {
            color: theme.palette.surface.defaultDisabled,
          },
          height: '6px',
          borderStyle: 'none',
        },
        rail: {
          opacity: 1.0,
          color: theme.palette.surface.indeterminate,
          '.Mui-disabled > &': {
            color: theme.palette.surface.primaryDisabled,
          },
          height: '4px',
          borderStyle: 'none',
        },
      },
    },
  },
});
